<template lang="pug">
section.singleAlso
  .singleAlso-titlebox: h2.singleAlso-title May also interest you
  .singleAlso-items
   .singleAlso-item(v-for='(item, i) in set', :class='"_" + (i + 1)'): ListingItem(:listing='item')
</template>

<script>
  // листинг в компонент
  import SvgComponent from '@/components/SvgComponent';
  import ListingItem from '@/components/ListingItem.vue';

  export default {
    props: ['listing'],
    data() {
      return {
        // listings: [],
        set: new Set(),
      };
    },
    components: {
      SvgComponent,
      ListingItem,
    },
    watch: {
      async listing() {
        // shitcode - do backend route
        if (this.listing?.for) {
          const allListingsForPurpose = await this.$store.dispatch('getListings', {
            purpose: this.listing.for,
          });
          const set = new Set();
          for (let i = 0; set.size < 3 && i < 100; i++) {
            const pickedRandomListing =
              allListingsForPurpose[Math.floor(Math.random() * allListingsForPurpose.length)];
            if (pickedRandomListing.id != this.listing.id) {
              set.add(pickedRandomListing);
            }
          }
          this.set = set;
          console.warn('set', set);
          this.$store.commit('pageLoaded');
        }
      },
    },
  };
</script>

<style lang="scss">
  .singleAlso {
    // tepm shit!
    height: auto;
    
    @include tablet {
      /* &-item:not(:last-child) {
        display: none;
      } */
    }

    display: contents;
    &-titlebox {
      /* margin-top: 150px; */
      @include tablet {
        margin-top: 56px;
      }
    }
    &-title {
      font-size: 64px;
      line-height: 77px;
      font-weight: bold;
      margin-bottom: 60px;
      font-family: 'Abhaya Libre';
      color: #1F1E1E;
      @include tablet {
        font-size: 42px;
        line-height: 43px;
        text-align: left;
        margin-bottom: 34px;
        width: 60%;
      }
    }
    &-items {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      margin-bottom: 120px;

      @include small {
        gap: 12px;
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: 60px;
 
      }


      @include phone {
        gap: 12px;
        grid-template-columns: 1fr;
        margin-bottom: 40px;
      }
    }
    &-item {
      // border: 1px solid black;
      
      display: flex;
      flex-direction: column;
      /* margin-bottom: 120px; */
      @include middle {
        
      }
     

      @include small {
        margin-bottom: 0;
        &:last-of-type {
          display: none;
        }
      }
     
      /* @include tablet {
        padding-top: 0 !important;
        grid-column: left-side / right-side !important;
        height: auto;
        padding-bottom: 55px;
      } */
    }
    &-image {
      /* height: 386px;
      width: 386px; */
      object-fit: cover;
      user-select: none;
    }
  }
</style>
